import React from 'react';
import PayrollHistoryPresentational from './payroll-history-presentational';

const PayrollHistoryFunctional = () => {
	return <PayrollHistoryPresentational />;
};
export default PayrollHistoryFunctional;
